import type { InteractionType } from '~/model/InteractionType';
import { VpButton, VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { InteractionContactDialog } from './InteractionContactDialog';

export const InteractionContact = ({
  interaction,
}: {
  interaction: InteractionType;
}) => {
  const t = useTranslations('INTERACTION');

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <div className="interaction-aside__contact">
      <VpButton
        size="medium"
        variant="secondary"
        startSlot={<VpIcon name="mail-send" />}
        onClick={() => setIsDialogOpen(true)}
        title={t('CONTACT_AUTHOR')}
      >
        {t('QUESTION')}
      </VpButton>
      <InteractionContactDialog
        open={isDialogOpen}
        interactionUri={interaction['@id']}
        handleOpen={setIsDialogOpen}
      />
    </div>
  );
};
